import { type ParsedLocation, useRouter } from '@tanstack/react-router';
import { useEffect } from 'react';

import { writeLastRoutePathToStorage } from './utils';

const trackRoute = ({ pathname, href }: ParsedLocation) => {
    if (!pathname.includes('/login')) {
        writeLastRoutePathToStorage(href);
    }
};

// Tracks the pages the user reached, not the navigations a guard or the leave prompt stopped
const useLastRouteTracker = () => {
    const router = useRouter();

    useEffect(() => {
        trackRoute(router.state.location);

        return router.subscribe('onResolved', ({ toLocation }) => trackRoute(toLocation));
    }, [router]);
};

export default useLastRouteTracker;
